module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-D05-clean-ba1328e4781d582a5148991c6a743c93.png";